export interface IStatusTypeList {
	value: IStatusType
	label: string,
	[key: string]: any
}

const STATUS_TYPES: IStatusTypeList[] = [
	{
		value: 'CREATED',
		label: 'Создан',
		labelRu: 'Создан',
		labelUz: 'Yaratilgan',
		labelOz: 'Яратилган',
		labelEn: 'Created',
		labelKaa: 'Жаратылған',
	},
	{
		value: 'NOT_VERIFIED',
		label: 'Не подтвержден',
		labelRu: 'Не подтвержден',
		labelUz: 'Tasdiqlanmagan',
		labelOz: 'Тасдиқланмаган',
		labelEn: 'Not confirmed',
		labelKaa: 'Тастыйықланбаған',
	},
	{
		value: 'T_PAYMENT',
		label: 'Оплатите за экзамен теория',
		labelRu: 'Оплатите за экзамен теория',
		labelUz: "Imtihon uchun pul to'lang nazariya",
		labelOz: 'Назария имтиҳонини тўлаш',
		labelEn: 'Pay for the theory exam',
		labelKaa: 'Теория имтиханы ушын төлең',
	},
	{
		value: 'T_EXAM',
		label: 'Сдайте экзамен теория',
		labelRu: 'Сдайте экзамен теория',
		labelUz: 'Imtihon topshiring nazariya',
		labelOz: 'Назария имтиҳонини топширинг',
		labelEn: 'Take the theory exam',
		labelKaa: 'Теория имтиханын тапсырыў',
	},
	{
		value: 'T_FAILED',
		label: 'Вы провалили теоретический экзамен',
		labelRu: 'Вы провалили теоретический экзамен',
		labelUz: "Siz nazariy imtihondan o'ta olmadingiz",
		labelOz: 'Сиз назарий имтиҳондан ўта олмадингиз',
		labelEn: 'You failed the theoretical exam.',
		labelKaa: 'Сиз теориялық имтиханнан жығылдыңыз',
	},
	{
		value: 'P_PAYMENT',
		label: 'Оплатите за экзамен практика',
		labelRu: 'Оплатите за экзамен практика',
		labelUz: "Imtihon uchun to'lang amaliyot",
		labelOz: 'Амалиёт имтиҳонини тўлаш',
		labelEn: 'Pay for the practice exam',
		labelKaa: 'Әмелият имтиханы ушын төлең',
	},
	{
		value: 'P_EXAM',
		label: 'Сдайте экзамен практика',
		labelRu: 'Сдайте экзамен практика',
		labelUz: "Amaliyot imtihonini topshiring",
		labelOz: 'Амалиёт имтиҳонини топширинг',
		labelEn: 'Take the practice exam',
		labelKaa: 'Әмелият имтиханын тапсырыў',
	},
	{
		value: 'P_FAILED',
		label: 'Вы провалили практический экзамен',
		labelRu: 'Вы провалили практический экзамен',
		labelUz: "Siz amaliy imtihondan o'ta olmadingiz",
		labelOz: 'Сиз амалий имтиҳондан ўта олмадингиз',
		labelEn: 'You failed the practical exam',
		labelKaa: 'Сиз әмелий имтиханнан өте алмадыңыз',
	},
	{
		value: 'COMPLETED',
		label: 'Успешно окончен',
		labelRu: 'Успешно окончен',
		labelUz: 'Muvaffaqiyatli yakunlandi',
		labelOz: 'Муваффақиятли якунланди',
		labelEn: 'Completed successfully',
		labelKaa: 'Табыслы тамамланды',
	},
];


export default STATUS_TYPES